export default __webpack_public_path__ + "static/media/polaroid10.2735d4e6.jpg";